module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "ml-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-0",
    attrs: {
      "dark": "",
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pa-0 ma-0"
  }, [(_vm.withBack) ? _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": "",
      "text": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("chevron_left")]), _vm._v(" Back\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), (_vm.template.id) ? _c('span', [_vm._v("\n          Editing template: " + _vm._s(_vm.template.name) + "\n        ")]) : _c('span', [_vm._v("\n          Create a new template\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.isDirty
    },
    on: {
      "click": _vm.sendExample
    }
  }, [_vm._v("\n          Send test\n        ")]), _vm._v(" "), (_vm.isEditMode) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "color": "primary",
      "disabled": _vm.errors.length > 0,
      "dark": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Create template")])], 1), _vm._v(" "), _c('v-divider')], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 my-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pl-0"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "hint": "A name that will help understand the purpose of this communication"
    },
    model: {
      value: (_vm.template.name),
      callback: function($$v) {
        _vm.$set(_vm.template, "name", $$v)
      },
      expression: "template.name"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-width": 200,
      "offset-x": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("settings")])], 1)]
      }
    }]),
    model: {
      value: (_vm.showSettings),
      callback: function($$v) {
        _vm.showSettings = $$v
      },
      expression: "showSettings"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("Advanced settings")]), _vm._v(" "), _c('v-card-text', [(_vm.isAdmin) ? [_c('v-text-field', {
    attrs: {
      "label": "practitioner id",
      "persistent-hint": "",
      "hint": "Use 0 to create a default template"
    },
    model: {
      value: (_vm.template.owner),
      callback: function($$v) {
        _vm.$set(_vm.template, "owner", $$v)
      },
      expression: "template.owner"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "This is a shared template"
    },
    model: {
      value: (_vm.template.shared),
      callback: function($$v) {
        _vm.$set(_vm.template, "shared", $$v)
      },
      expression: "template.shared"
    }
  }), _vm._v(" "), _c('hr')] : _vm._e(), _vm._v(" "), [_c('v-subheader', {
    staticClass: "pa-0 mb-0 overline mt-3"
  }, [_vm._v("Share with your Spaces")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Add to UI"
    },
    model: {
      value: (_vm.template.allow_ad_hoc_sending),
      callback: function($$v) {
        _vm.$set(_vm.template, "allow_ad_hoc_sending", $$v)
      },
      expression: "template.allow_ad_hoc_sending"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.transports,
      "label": "Default sending option"
    },
    model: {
      value: (_vm.template.preferred_transport),
      callback: function($$v) {
        _vm.$set(_vm.template, "preferred_transport", $$v)
      },
      expression: "template.preferred_transport"
    }
  })]], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "2",
      "label": "Description",
      "hint": "A brief description of the purpose of this template"
    },
    model: {
      value: (_vm.template.description),
      callback: function($$v) {
        _vm.$set(_vm.template, "description", $$v)
      },
      expression: "template.description"
    }
  }), _vm._v(" "), _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setLastFocussed("short-message-textarea")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.short')))]), _vm._v(" "), _c('v-tab', {
    on: {
      "click": function($event) {
        return _vm.setLastFocussed("email-content")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('tabs.long')) + "\n        ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('help-popover', {
    staticClass: "mt-3 mr-1"
  }, [_c('v-subheader', {
    staticClass: "overline ml-0 pl-0"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('info.merge_tags_title')) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info.merge_tags')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('info.merge_tags_example')))])], 1), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "small": "",
      "box": "",
      "label": "Merge tags",
      "items": _vm.merge_tags,
      "return-object": "",
      "item-text": "text",
      "item-value": "value"
    },
    on: {
      "change": _vm.insertVariable
    },
    model: {
      value: (_vm.selectedMergeTag),
      callback: function($$v) {
        _vm.selectedMergeTag = $$v
      },
      expression: "selectedMergeTag"
    }
  }), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-tab-item', [_c('v-textarea', {
    attrs: {
      "box": "",
      "counter": "",
      "auto-grow": "",
      "persistent-hint": "",
      "no-resize": false,
      "id": "short-message-textarea",
      "rows": 25,
      "label": _vm.$t("forms.shortmessage.label"),
      "hint": _vm.$t("forms.shortmessage.hint")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("short-message-textarea")
      }
    },
    model: {
      value: (_vm.template.short_message),
      callback: function($$v) {
        _vm.$set(_vm.template, "short_message", $$v)
      },
      expression: "template.short_message"
    }
  })], 1), _vm._v(" "), _c('v-tab-item', [_c('v-text-field', {
    attrs: {
      "box": "",
      "id": "email-subject",
      "label": _vm.$t("forms.email.subject")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("email-subject")
      }
    },
    model: {
      value: (_vm.template.subject),
      callback: function($$v) {
        _vm.$set(_vm.template, "subject", $$v)
      },
      expression: "template.subject"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "box": "",
      "no-resize": false,
      "id": "email-content",
      "rows": 25,
      "label": _vm.$t("forms.email.content")
    },
    on: {
      "focus": function($event) {
        return _vm.setLastFocussed("email-content")
      }
    },
    model: {
      value: (_vm.template.message),
      callback: function($$v) {
        _vm.$set(_vm.template, "message", $$v)
      },
      expression: "template.message"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2 my-4",
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading pb-1"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('titles.preview.main')) + "\n      ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.template.short_message || _vm.template.message || _vm.template.subject) ? _c('v-card-text', [(_vm.template.short_message) ? _c('div', [_c('h3', {
    staticClass: "overline mt-3"
  }, [_vm._v(_vm._s(_vm.$t('titles.preview.shortmessage')))]), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "value": _vm.parsedShortMessage,
      "auto-grow": "",
      "box": "",
      "readonly": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.template.subject || _vm.template.message) ? _c('div', [_c('h3', {
    staticClass: "overline mt-3"
  }, [_vm._v(_vm._s(_vm.$t('titles.preview.email')))]), _vm._v(" "), _c('strong', [_vm._v("Subject:")]), _vm._v(" " + _vm._s(_vm.parsedSubject) + "\n          "), _c('div', [_c('strong', {
    staticClass: "overline"
  }, [_vm._v("Message:")]), _c('br'), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.parsedMessage)
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? [_c('h3', {
    staticClass: "overline mt-4"
  }, [_vm._v("Raw data")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.payload))])] : _vm._e()], 2) : _c('v-card-text', [_c('v-icon', [_vm._v("info")]), _vm._v("\n        Start typing your message and the preview will show up here.\n      ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.isEditMode) ? _c('v-btn', {
    attrs: {
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0,
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.request.loading,
      "disabled": _vm.errors.length > 0
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Create template")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9c667f6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/CommunicationTemplateForm.vue
// module id = 1531
// module chunks = 9